import React, { useState } from 'react';
import { ChevronDown as ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Is this really designed for women over 50 specifically?',
  answer: 'Yes. The guide centers the practical breakfast needs highlighted in this page: satisfying, bread-free ideas with protein-forward and blood-sugar-friendly choices for this stage of life.'
}, {
  question: 'Do I need to be a good cook?',
  answer: 'No. The recipes are designed to be straightforward, with most ready in under 10 minutes and clear prep-ahead options for busy mornings.'
}, {
  question: 'Are the ingredients expensive or hard to find?',
  answer: 'No. The guide focuses on accessible everyday ingredients, and your bonus Smart Grocery List helps you keep useful staples on hand.'
}, {
  question: 'I have diabetes / high cholesterol / other health conditions. Is this safe for me?',
  answer: 'This digital guide is educational and informational only, not medical advice. Please consult your healthcare provider before making significant dietary changes.'
}, {
  question: 'How do I receive the guide after purchasing?',
  answer: 'You receive instant access, with the digital guide delivered to your email immediately after checkout.'
}, {
  question: "What if it doesn't work for me?",
  answer: 'You are covered by the 7-Day Money-Back Guarantee. Contact us within 7 days for a 100% refund, with no questions asked.'
}];
export function GuaranteeFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <>
      <section className="bg-olive py-20 text-cream sm:py-24" data-id="element-52">
        <div className="mx-auto grid max-w-6xl gap-10 px-5 lg:grid-cols-[16rem_1fr] lg:items-center lg:px-8" data-id="element-53">
          <figure className="mx-auto w-full max-w-[13rem] rounded-full border-4 border-sage/35 bg-forest/20 p-2 shadow-xl shadow-forest/20 lg:max-w-[16rem]" data-id="element-54">
            <img src="https://cdn.magicpatterns.com/uploads/hLrJKJvnhAFdQyaS2C8HQZ/Garantia.png" alt="7-Day Money-Back Guarantee seal" className="aspect-square w-full rounded-full object-cover" data-id="element-55" />
          </figure>

          <div className="text-center lg:text-left" data-id="element-56">
            <p className="text-sm font-bold uppercase tracking-[0.16em] text-sage" data-id="element-57">
              Our promise to you
            </p>
            <h2 className="mt-3 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-58">
              Try it completely risk-free
            </h2>
            <h3 className="mt-6 text-lg font-extrabold" data-id="element-59">
              7-Day Money-Back Guarantee — 100% refund, zero hassle
            </h3>
            <p className="mt-3 max-w-3xl leading-7 text-cream/80" data-id="element-60">
              I know you&apos;ve probably tried things before that didn&apos;t
              deliver. That&apos;s why we take <strong data-id="element-61">ALL</strong> the risk. If
              you go through the guide and don&apos;t feel a difference in 7
              days — or if it&apos;s simply not right for you — contact us and
              we&apos;ll refund every cent. No questions. No fine print. Your
              trust matters more than the sale.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white py-20 sm:py-24" data-id="element-62">
        <div className="mx-auto max-w-3xl px-5 lg:px-8" data-id="element-63">
          <div className="text-center" data-id="element-64">
            <p className="eyebrow" data-id="element-65">Common questions</p>
            <h2 className="section-title mt-3" data-id="element-66">
              Questions women ask before buying
            </h2>
          </div>
          <div className="mt-10 divide-y divide-forest/10 rounded-2xl border border-forest/10" data-id="element-67">
            {faqs.map((faq, index) => {
            const isOpen = index === openIndex;
            return <div key={faq.question} data-id="element-68">
                  <button className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left font-extrabold text-forest focus:outline-none focus-visible:ring-4 focus-visible:ring-terracotta/30" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} data-id="element-69">
                    <span data-id="element-70">{faq.question}</span>
                    <ChevronDownIcon size={20} className={`shrink-0 text-terracotta transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-71" />
                  </button>
                  {isOpen && <div className="px-5 pb-5 text-sm leading-7 text-forest/70" data-id="element-72">
                      {faq.answer}
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}